/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Ref_H1Inputs */

const en_diff_ref_h1 = /** @type {(inputs: Diff_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output`)
};

const ko_diff_ref_h1 = /** @type {(inputs: Diff_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출력`)
};

const ja_diff_ref_h1 = /** @type {(inputs: Diff_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力`)
};

/**
* | output |
* | --- |
* | "Output" |
*
* @param {Diff_Ref_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_ref_h1 = /** @type {((inputs?: Diff_Ref_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Ref_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_ref_h1(inputs)
	if (locale === "ko") return ko_diff_ref_h1(inputs)
	return ja_diff_ref_h1(inputs)
});